var map = {
	"./assign_employees.svg": 896,
	"./award_closedloop.svg": 897,
	"./award_production.svg": 898,
	"./award_renting.svg": 899,
	"./award_reuse.svg": 900,
	"./bck info red.svg": 901,
	"./bck_award.svg": 902,
	"./bck_event.svg": 903,
	"./bck_market.svg": 904,
	"./bck_refurbishing.svg": 905,
	"./bck_rental.svg": 906,
	"./bck_result mining.svg": 907,
	"./bck_result producing.svg": 908,
	"./bck_result recycling.svg": 909,
	"./img_circulareconomy.svg": 910,
	"./market.svg": 911,
	"./mine.svg": 912,
	"./wastedepot.svg": 913
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 245;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/info nonrecursive ./~/raw-loader!\.svg$
// module id = 245
// module chunks = 2